import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "./button";

interface SelectableRowProps {
  label: string;
  isSelected: boolean;
  onToggle: () => void;
  disabled?: boolean;
  className?: string;
}

export function SelectableRow({
  label,
  isSelected,
  onToggle,
  disabled = false,
  className,
}: SelectableRowProps) {
  return (
    <Button
      type="button"
      variant="text"
      onClick={onToggle}
      disabled={disabled}
      className={cn(
        "w-full justify-start items-center gap-3 h-auto px-3 py-2 font-normal underline-none !whitespace-normal",        
        className
      )}
    >
      <div
        className={cn(
          "w-4 h-4 border rounded flex items-center justify-center flex-shrink-0",
          isSelected ? "bg-primary border-primary" : "border-input"
        )}
      >
        {isSelected && <Check className="w-3 h-3 text-primary-foreground" />}
      </div>
      <span className="flex-1 text-left">{label}</span>
    </Button>
  );
}

